/* eslint-disable dot-notation */
import React, { useEffect, useState } from 'react';

import OkrMetricGraph from './okr_metric_graph';
import GraphHeader from './okr_graph/kr_graph_header';
import GraphFooter from './okr_graph/kr_graph_footer';
import MetricOtherGoal from './metric_other_goals';
import * as OkrPopUpConst from '../../constants/okrPopUp.constants';
import KrService from '../../services/kr.service';
import { resolveShowEnhancedKrChart, withChildMit } from '../../../components/krDetails/useEnhancedKrChartToggle';
import { stashKrChartSelection } from '../../../components/krDetails/KrChartEnhanced.component';
import GoalServices from '../../../services/goal.services';
import * as OkrPopAction from '../../actions/okr_popup.action';
import { useTranslation } from 'react-i18next';

const service = new KrService();

const MetricGraph = ({ goalData, dispatch }: any) => {
    const { t } = useTranslation();
    const goal = goalData.goals || [];
    const metricsData = goalData.goalPopUpMetric || [];
    const currentUserFullName = goalData.currentUserFullName || null;
    const selectedMetId = goalData.selectedMetricId || goalData.selectedMetric;
    const metrics = metricsData.find((m: any) => m.id == selectedMetId);

    const showEnhancedChart = metrics
        ? resolveShowEnhancedKrChart(withChildMit(metrics))
        : false;
    const [pageSource, setPageSource] = useState('okrDeatils');
    const [subGraphData, setSubGraphData] = useState({});
    const [selectedUser, setselectedUser] = useState({});

    useEffect(() => {
        if (metrics != undefined
                && typeof metrics.chart_data == 'undefined'
                && !showEnhancedChart
                && (
                    metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS
                    || metrics.mirrorSource != OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS
                )
        ) {
            const p = { goalId: goal.id, metricId: selectedMetId };
            const contentId = document.getElementById('content');
            showLoaderWidget(contentId);
            service.getMetricChartData(p)
                .then((response) => {
                    removeLoader();
                    dispatch(
                        OkrPopAction.UpdateMetricGraphData({
                            metricId: selectedMetId,
                            chartData: response.data[0]
                        })
                    )
                })
                .catch((err: any) => {
                    removeLoader();
                    console.log('err', err);
                });
        }
        setPageSource('okrDeatils');
    // eslint-disable-next-line
    }, [selectedMetId, showEnhancedChart]);

    // Mirrors KR Details onRefresh: recalculate, wait 3s for OCE, reload chart data.
    const [chartRefreshKey, setChartRefreshKey] = useState(0);
    const onKrUpdated = () => {
        stashKrChartSelection();
        const bump = () => setChartRefreshKey((k) => k + 1);
        new GoalServices().recalculateMetric(selectedMetId)
            .then(() => new Promise((resolve) => setTimeout(resolve, 3000)))
            .then(bump, bump);
    };

    const updateMetricAsSubGraph = (subgraph, user) => {
        setPageSource('subGraph');
        setSubGraphData(subgraph);
        setselectedUser(user);
    }

    const clickBackButton = () => {
        setselectedUser({});
        setSubGraphData({});
        setPageSource('');
    }

    return (
        <>
            {
                (
                    metrics != undefined
                        && (
                            metrics.source == OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS
                            || metrics.mirrorSource == OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS
                        )
                )
                    ? <MetricOtherGoal metricId={metrics.id} />
                    : (
                        <div className="okr-chart-section">
                            <div className="metric-render-details">
                                {
                                    metrics && (
                                        <div className="kr-charts">
                                            <div
                                                className="goal-chart  goal-line-bar-chart"
                                                id={`goal-metrics-${metrics.id}`}
                                                data-goal-id={goal.id}
                                            >
                                                <GraphHeader metric={metrics} />
                                                <div className="kr-chart-scroll-content-container">
                                                <div className="kr-chart-scroll-content">
                                                    {pageSource == 'subGraph'
                                                        && (
                                                            <>
                                                                <div className="survey-person-name left">
                                                                    {selectedUser['name']}
                                                                </div>
                                                                <div
                                                                    className="survey-back-button right"
                                                                    data-metric-id={metrics.id}
                                                                >
                                                                    <div
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        className="survey-back-button-inside"
                                                                        onClick={(e) => clickBackButton()}
                                                                        onKeyDown={(e) => clickBackButton()}

                                                                    >
                                                                        {t('back')}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    <OkrMetricGraph
                                                        metrics={metrics}
                                                        refreshKey={chartRefreshKey}
                                                        Goals={goal}
                                                        pageSource={pageSource}
                                                        surveyUserSelected={selectedUser}
                                                        subGraphData={subGraphData}
                                                        isEnabledBiweeklyKR={goalData.isEnabledBiweeklyKR}
                                                        isStretchEnabled={goalData.isStretchEnabled}
                                                    />
                                                <GraphFooter
                                                    metric={metrics}
                                                    goal={goal}
                                                    dispatch={dispatch}
                                                    onKrUpdated={onKrUpdated}
                                                    currentUserFullName={currentUserFullName}
                                                    updateMetricAsSubGraph={updateMetricAsSubGraph}
                                                />
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
            }
        </>
    )
}

export default MetricGraph;
